import React from 'react';

import './process.scss';

const Process = () => (
  <div className='process'>
    <h1 className='process__title'>How We Work</h1>
    <div className='process__container'>
      <div className='process__block'>
        <span>1</span>
        <h4 className='process__block__title'>CONCEPT</h4>
        <div className='process__block__text'>
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Doloribus,
          quam?
        </div>
        <a href=' ' className='process__block__link'>
          Read More
        </a>
      </div>
      <div className='process__block'>
        <span>2</span>
        <h4 className='process__block__title'>IDEA</h4>
        <div className='process__block__text'>
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Doloribus,
          quam?
        </div>
        <a href=' ' className='process__block__link'>
          Read More
        </a>
      </div>
      <div className='process__block'>
        <span>3</span>
        <h4 className='process__block__title'>DESIGN</h4>
        <div className='process__block__text'>
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Doloribus,
          quam?
        </div>
        <a href=' ' className='process__block__link'>
          Read More
        </a>
      </div>
      <div className='process__block'>
        <span>4</span>
        <h4 className='process__block__title'>EXECUTION</h4>
        <div className='process__block__text'>
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Doloribus,
          quam?
        </div>
        <a href=' ' className='process__block__link'>
          Read More
        </a>
      </div>
    </div>
  </div>
);

export default Process;
